import { castArray, isType } from '../utils/'
import VNode from './vnode'

export default function createElement (tag: string, props: object, children: any) {
  return children == null && isType(props, ['string', 'array'])
    ? new VNode(tag, undefined, castArray(props))
    : new VNode(tag, props, castArray(children))
}
